import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import {
  AssignAgentToConversationSchema,
  AssigneeSchema,
  AssignInboxToConversationSchema,
  AssignLabelToConversationSchema,
  ConversationUserSchema,
  HandoverHistorySchema,
  HistoryEntrySchema,
  LabelSchema,
} from './chat.schema';

const { CONVERSATION } = PERMISSIONS;

export const chatContract = createRESTContract({
  getConversationsList: {
    path: '/conversations',
    method: 'GET',
    query: z.object({
      inbox: z.string().optional(),
      chatStatus: z.union([z.literal('open'), z.literal('resolved')]),
    }),
    permissions: [CONVERSATION.CONVERSATION_MANAGE],
    response: z.array(ConversationUserSchema),
  },
  getConversation: {
    path: '/conversations/:conversationId',
    method: 'GET',
    permissions: [CONVERSATION.CONVERSATION_MANAGE],
    response: ConversationUserSchema,
  },
  getConversationLabels: {
    path: '/conversations/:conversationId/labels',
    method: 'GET',
    permissions: [CONVERSATION.CONVERSATION_MANAGE],
    response: z.array(LabelSchema),
  },
  getAssigneeListForConversation: {
    path: '/conversations/:conversationId/assignees',
    method: 'GET',
    permissions: [CONVERSATION.CONVERSATION_MANAGE],
    response: z.array(AssigneeSchema),
  },
  getConversationMessages: {
    path: '/conversations/:conversationId/messages',
    method: 'GET',
    permissions: [CONVERSATION.CONVERSATION_MANAGE],
    response: z.array(HistoryEntrySchema),
  },
  assignAgentToConversation: {
    path: '/conversations/:conversationId/agent',
    method: 'POST',
    permissions: [CONVERSATION.CONVERSATION_MANAGE],
    body: AssignAgentToConversationSchema,
    response: z.object({
      assignedAgent: z.union([AssigneeSchema, z.undefined()]),
      lastHandoverHistory: z.union([HandoverHistorySchema, z.undefined()]),
    }),
  },
  assignInboxToConversation: {
    path: '/conversations/:conversationId/inbox',
    method: 'POST',
    permissions: [CONVERSATION.CONVERSATION_MANAGE],
    body: AssignInboxToConversationSchema,
    response: z.void(),
  },
  assignLabelToConversation: {
    path: '/conversations/:conversationId/labels',
    method: 'POST',
    permissions: [CONVERSATION.CONVERSATION_MANAGE],
    body: AssignLabelToConversationSchema,
    response: z.void(),
  },
  removeLabelFromConversation: {
    path: '/conversations/:conversationId/labels/:labelId',
    method: 'DELETE',
    body: z.undefined(),
    permissions: [CONVERSATION.CONVERSATION_MANAGE],
    response: z.void(),
  },
  resolveConversation: {
    path: '/conversations/:conversationId/resolve',
    method: 'POST',
    permissions: [CONVERSATION.CONVERSATION_MANAGE],
    body: z.undefined(),
    response: z.void(),
  },
});
